import React from "react";
import styles from "./FilePreview.module.css";
import EditableImageCanvas from "./EditableImageCanvas";

const FilePreview = ({
  file,
  preview,
  editable = false,
  editData,
  onEditChange,
  onResetEdit,
}) => {
  if (!file) return null;

  const isImage = file.type.startsWith("image/");

  if (editable && isImage) {
    return (
      <EditableImageCanvas
        imageUrl={preview}
        editData={editData}
        onChange={onEditChange}
      />
    );
  }

  return (
    <div className={styles.previewContainer}>
      {isImage ? (
        <img src={preview} alt="preview" className={styles.image} />
      ) : (
        <div className={styles.iconContainer}>
          <p>{file.name}</p>
        </div>
      )}
    </div>
  );
};

export default FilePreview;
